import * as React from 'react';

interface Props {
	name: string,
	id: string,
	label?: string,
}

const qdesk = (window as any).qdesk
const $ = (window as any).$

class UserTooltip extends React.Component<Props> {
	constructor(props) {
		super(props);
		this.userTooltip = React.createRef();
	}

	userTooltip;

	componentDidMount() {
		if (qdesk.userData && this.props.id)
			qdesk.userData.tryAppendTooltip($(this.userTooltip.current), '/Users/PreviewUser');
	}

	componentDidUpdate(prevProps) {
		if (qdesk.userData && this.props.id)
			qdesk.userData.refreshTooltipForUser($(this.userTooltip.current), this.props.id, this.props.name);
	}

	render() {
		return <span ref={this.userTooltip} title={this.props.label} className="user user-tooltip" data-user={this.props.id}>{this.props.name}</span>
	}
}

export default UserTooltip;